import { css } from "styled-components";

export const theme = {
  colors: {
    RED: "#E35054",
    GREEN: "#38C7AB",
    LIGHT_SUCCESS: "#ECFBF8",
    DARK_SUCCESS: "#15CDA8",
    SELECTED: "#2a8cfc",
    SEARCH_BAR: "#717171",
    GREY_1: "#EEEEEE",
    GREY_2: "#ABABAB",
    GREY_3: "#F6F6F6",
    TEXT_GREY: "#6E6E6E",
    WHITE: "white",
    BLUE: "#2B8CFC",
  },
  css: {
    BOTTOM_SHADOW: css`
      -webkit-box-shadow: 0px 4px 13px -12px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: 0px 4px 13px -12px rgba(0, 0, 0, 0.75);
      box-shadow: 0px 4px 13px -12px rgba(0, 0, 0, 0.75);
    `,
    TOP_SHADOW: css`
      -webkit-box-shadow: 0px -4px 13px -12px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: 0px -4px 13px -12px rgba(0, 0, 0, 0.75);
      box-shadow: 0px -4px 13px -12px rgba(0, 0, 0, 0.75);
    `,
  },
};
